import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=02e3a0aa&scoped=true&"
import script from "./comment-item.vue?vue&type=script&lang=js&"
export * from "./comment-item.vue?vue&type=script&lang=js&"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=02e3a0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3a0aa",
  null
  
)

export default component.exports